import React from "react";
import { Button, Modal, Spinner } from "react-bootstrap"; 
import { APP_COLOR, LINEAR_GRADIENT_BG } from "../const";

export default function ComfirmModal({
  showConfirmModal,
  handleCancel,
  handleConfirm,
  loadingConfirm,
  title,
  text,
}) {
  return (
    <Modal
      show={showConfirmModal}
      onHide={handleCancel}
      backdrop="static"
      centered
      zIndex={9999}
      keyboard={false}>
      <Modal.Body>
        <div
          style={{
            width: "100%",
            height: "12em",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}>
          <div
            style={{
              width: "5em",
              height: "5em",
              marginBottom: ".5em",
              border:"1px dashed #ddd",
              borderRadius:'40em', overflow:'hidden'
            }}>
            <img
              src="/assets/image/packxi-tab.png"
              width={"100%"}
              style={{objectFit:'contain'}}
              height={"100%"}
              alt="wninngImage"
            />
          </div>
          <h4>{title ?? "ແຈ້ງເຕືອນ"}</h4>
          <p>{text}</p>
        </div>
      </Modal.Body>
      <Modal.Footer
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          border: "none",
        }}>
        <Button variant="outline-secondary" onClick={handleCancel}>
          ຍົກເລິກ
        </Button>
        <Button
          style={{
            background: LINEAR_GRADIENT_BG,
            color: "#fff",
            border: `1px solid ${APP_COLOR}`,
          }}
          onClick={handleConfirm}>
          {loadingConfirm ? <Spinner size="sm" /> : "ຢືນຢັນ"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
